import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const ToastWrapper = styled(ToastContainer)`
  bottom: 60px;
`;
